import {
  GreyGrey10,
  GreyGrey70,
  Primary14SemiBold,
  Primary13Regular,
  GreyGrey60,
  Card,
  InputSelectControlField,
  Tooltip,
  Box,
  Flex,
  Center
} from '@sequencehq/core-components'
import { Dashboardv99990101CommonModels } from '@sequencehq/api/dashboard/v99990101'
import { useState } from 'react'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { RefreshAccountsIcon } from 'Integrations/integrationsConfig/quickBooks/RefreshAccountsIcon'

type QuickbooksAccount =
  Dashboardv99990101CommonModels.QuickbooksAccount.QuickbooksAccount

interface Props {
  fieldsConfig: {
    defaultAccount: {
      value: string
      onChange: (value: string) => void
    }
  }
  quickbooksAccounts: QuickbooksAccount[]
}

export const DefaultQuickBooksAccountCard = ({
  fieldsConfig,
  quickbooksAccounts
}: Props) => {
  const [isRefreshing, setIsRefreshing] = useState(false)
  const syncQuickbooksAccountsMutator = useMutation(
    dashboard20240730Client.postSyncQuickbooksAccounts
  )

  const quickbooksAccountsOptions = quickbooksAccounts.map(account => ({
    value: account.id,
    label: account.name ?? account.id
  }))

  return (
    <Card>
      <Flex
        data-testid="quickbooksIntegration.defaultAccount"
        gap={4}
        flexDirection="column"
      >
        <Flex gap={1} flexDirection="column">
          <Box {...Primary14SemiBold}>Accounts</Box>
          <Box {...Primary13Regular} color={GreyGrey70}>
            Set a default account for unmapped invoice line items or products.
            To map products to QuickBooks Items, edit the product directly.
          </Box>
        </Flex>
        <Flex
          backgroundColor={GreyGrey10}
          borderRadius={6}
          alignItems="center"
          alignContent="center"
          width="100%"
          p={4}
          gap={2}
        >
          <Flex alignItems="end">
            <InputSelectControlField
              width="400px"
              label="Default account name"
              data-testid="quickbooksIntegration.defaultAccount.account"
              placeholder="Select default account"
              options={quickbooksAccountsOptions}
              initialValue={fieldsConfig.defaultAccount.value}
              onChange={fieldsConfig.defaultAccount.onChange}
              disabled={isRefreshing}
            />
            <Tooltip label="Trigger a refresh" placement="top" hasArrow>
              <Center
                boxSize="32px"
                cursor="pointer"
                as="span"
                display="inline-flex"
                onClick={async () => {
                  setIsRefreshing(true)

                  await syncQuickbooksAccountsMutator.mutateAsync()

                  setTimeout(() => {
                    setIsRefreshing(false)
                  }, 1000)
                }}
                data-testid="quickbooksIntegration.defaultAccount.refreshAccounts"
                aria-label="Refresh accounts"
              >
                <RefreshAccountsIcon
                  isRefreshing={isRefreshing}
                  color={GreyGrey60}
                />
              </Center>
            </Tooltip>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}
